import { createBrowserHistory,createHashHistory } from 'history';

const history = window.cordova ? createHashHistory() : createBrowserHistory();

export default history;
